import React from 'react'
import { Helmet } from 'react-helmet'
import { default as Container } from '../container'
import { default as Content } from './content'

const Page = () => {
  return (
    <Container active={3}>
      <Helmet>
        <title>Premio de Excelencia Prima AFP | Reconocimiento y Calidad</title>
        <meta name="title" content="Premio de Excelencia Prima AFP | Reconocimiento y Calidad" data-react-helmet="true"/>
        <meta name="description" content="Conoce el Premio de Excelencia de Prima AFP, reconocimiento a nuestro compromiso con la calidad en servicios previsionales y atención al afiliado en el sistema privado de pensiones." data-react-helmet="true"/>
      </Helmet>

      <Content />
    </Container>
  )
}

export default Page
